import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/privacy-policy/hero";
import PP from "../components/privacy-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Invisalign Ilkley - Protecting Your Data</title>
        <meta
          name="description"
          content="Read our privacy policy to understand how Invisalign Ilkley protects your data. Your privacy is important to us, and we are committed to safeguarding your information."
        />
        <link
          rel="canonical"
          href="https://www.invisalign-ilkley.com/privacy-policy"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
